import AuthorizationPage from './screens/AuthorizationPage';
import Dashboard from './layouts/Dashboard/Dashboard';
import {
  ForgotPasswordForm,
  LoginForm,
  RegisterForm,
  ResetPasswordForm,
} from './components/Forms';
import Logout from './screens/Logout';
import AccountActivationInfo from './screens/AccountActivation/AccountActivationInfo';
import ActivateAccount from './screens/AccountActivation/ActivateAccount';
import DashboardWithButtons from './layouts/Dashboard/DashboardWithButtons';
import AccountSettings from './screens/AccountSettings/AccountSettings';
import Bar from './layouts/Dashboard/Bar';
import DeletedAccountInfo from './screens/AccountSettings/DeletedAccountInfo';
import IndividualClient from './screens/IndividualClient/IndividualClient';
import PermissionsManagement from './screens/PermissionsManagement/PermissionsManagement';
import SetPassword from './screens/SetPassword';
import MultipleClients from './screens/MultipleClients/MultipleClients';
import ParametersAnimals from './screens/ParametersAnimals/ParametersAnimals';
import ParametersPlants from './screens/ParametersPlants/ParametersPlants';
import Simulation from './screens/Simulation/Simulation';
import AddSimulation from './screens/Simulation/AddSimulation';
import SimulationView from './screens/Simulation/SimulationView';

const routes = [
  {
    path: '/login',
    component: AuthorizationPage,
    form: LoginForm,
    title: 'AgroWe-Logowanie',
    exact: true,
  },
  {
    path: '/forgot-password',
    component: AuthorizationPage,
    form: ForgotPasswordForm,
    title: 'AgroWe-Przypomnij hasło',
    titleSubmitted: 'AgroWe-Link wysłany',
    exact: true,
  },
  {
    path: '/changePassword',
    component: AuthorizationPage,
    form: ResetPasswordForm,
    title: 'AgroWe-Reset hasła',
    titleSubmitted: 'AgroWe-Hasło zmienione',
    exact: true,
  },
  {
    path: '/logout',
    component: Logout,
    title: 'AgroWe-Wylogowywanie...',
    exact: true,
    private: true,
  },
  {
    path: '/register',
    component: AuthorizationPage,
    form: RegisterForm,
    title: 'AgroWe-Rejestracja',
    titleSubmitted: 'AgroWe-Zarejestrowano',
    exact: true,
  },
  {
    path: '/activate-info',
    component: AccountActivationInfo,
    title: 'AgroWe-Aktywacja konta',
    exact: true,
  },
  {
    path: '/activate/:userCode',
    component: ActivateAccount,
    title: 'AgroWe-Aktywacja konta',
    exact: true,
  },
  {
    path: '/dashboard/individual-client/:applicationID',
    component: Dashboard,
    content: IndividualClient,
    title: 'AgroWe-Klient indywidualny',
    exact: true,
    private: true,
  },
  {
    path: '/dashboard/multiple-clients',
    component: Dashboard,
    content: MultipleClients,
    title: 'AgroWe-Wielu klientów',
    exact: true,
    private: true,
  },
  {
    path: '/dashboard/permissions-management',
    component: Dashboard,
    content: PermissionsManagement,
    title: 'AgroWe-Zarządzanie uprawnieniami',
    exact: true,
    private: true,
    admin: true,
  },
  {
    path: '/dashboard/parameters-animals',
    component: Dashboard,
    content: ParametersAnimals,
    title: 'AgroWe-Wskaźniki zwierzęce',
    exact: true,
    private: true,
  },
  {
    path: '/dashboard/parameters-plants',
    component: Dashboard,
    content: ParametersPlants,
    title: 'AgroWe-Wskaźniki roślinne',
    exact: true,
    private: true,
  },
  {
    path: '/dashboard/simulation/:simulationID',
    component: Dashboard,
    content: SimulationView,
    title: 'AgroWe-Podgląd symulacji',
    exact: true,
    private: true,
  },
  {
    path: '/dashboard/simulation',
    component: Dashboard,
    content: Simulation,
    title: 'AgroWe-Symulacja',
    exact: true,
    private: true,
  },
  {
    path: '/dashboard/add-simulation',
    component: Dashboard,
    content: AddSimulation,
    title: 'AgroWe-Dodaj symulację',
    exact: true,
    private: true,
  },
  {
    path: '/account-settings',
    component: DashboardWithButtons,
    buttons: ['ZMIEŃ HASŁO', 'USUŃ KONTO'],
    content: AccountSettings,
    exact: true,
    private: true,
  },
  {
    path: '/account-deleted',
    component: Bar,
    content: DeletedAccountInfo,
    exact: true,
  },
  {
    path: '/set-password',
    component: Bar,
    content: SetPassword,
    exact: true,
  },
];
export default routes;
